var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fulfillment-timer-container"},[_c('span',{staticClass:"fulfillment-timer"},[_vm._v(_vm._s(_vm.timerFormat))]),_c('svg',{style:({
      strokeDasharray: '132px',
      strokeDashoffset: `${_vm.getTimeProgress}px`,
      transform: 'rotate(-90deg)'
    }),attrs:{"height":"46","width":"46"}},[_c('circle',{attrs:{"cx":"23","cy":"23","r":"21","stroke":_vm.color.stroke,"stroke-width":"4","fill":_vm.color.fill}}),_vm._v(" "+_vm._s(_vm.time)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }